"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var withSVGIcon_1 = require("../withSVGIcon");
var Icon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? '#000' : _b;
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx("path", { d: "M9 18.0032H12.5227V15.6033C12.5227 13.875 13.0952 12.521 13.9208 11.2219L11.8512 10C10.321 11.244 9 13.6108 9 15.6254V18.0032ZM14.5593 18.0032H18.082V15.6033C18.082 13.875 18.6545 12.521 19.4801 11.2219L17.4105 10C15.8803 11.244 14.5593 13.6108 14.5593 15.6254V18.0032Z", fill: fill }, void 0) }, void 0));
};
exports.QuoteIcon = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 28 28' });
//# sourceMappingURL=QuoteIcon.js.map